// extracted by mini-css-extract-plugin
export var currentStep = "_bo-2";
export var nodeCard = "_bo-0";
export var pathHighlighted = "_bo-1";